var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "userAccount" },
    [
      _vm.isLoggedIn
        ? [
            _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
              _c(
                "svg",
                {
                  staticClass: "css-i6dzq1",
                  attrs: {
                    viewBox: "0 0 24 24",
                    width: "24",
                    height: "24",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                },
                [
                  _c("path", {
                    attrs: { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }
                  }),
                  _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } })
                ]
              )
            ])
          ]
        : [
            _vm.showLogin
              ? _c(
                  "a",
                  {
                    attrs: {
                      "data-testing": "login-select",
                      href: _vm.isLogin ? "javascript:void(0)" : "#login",
                      "data-toggle": _vm.isLogin ? false : "modal",
                      "aria-label": _vm.$translate("Ceres::Template.login")
                    },
                    on: {
                      click: function($event) {
                        _vm.createLoginModal()
                        _vm.createRegisterModal()
                        _vm.unmarkInputFields()
                      }
                    }
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "css-i6dzq1",
                        attrs: {
                          viewBox: "0 0 24 24",
                          width: "24",
                          height: "24",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          fill: "none",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                          }
                        }),
                        _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } })
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }